import { deltaE76, linearToLab, type LinearRGB } from '../../../core/color';
import type { PaletteClass } from '../../../data/types';

/** Picks among a palette class's cluster centres, for buildings whose own painted colour is measured. */

function luminance(c: LinearRGB): number {
  return 0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2];
}

/**
 * The painted Nieuwe Kerk roof (Lab 31.5 -7.0 25.8) is darker than the slate most sampled roofs
 * draw; sunlit, the shade ramp lifts the middle slate centres to L* 45-48, and only the darkest
 * stays near the painting.
 */
export function darkestCentre(cls: PaletteClass): LinearRGB {
  return cls.centres.reduce(
    (a, c) => (luminance(c.linear) < luminance(a) ? c.linear : a),
    cls.median.linear
  );
}

/** The class's centre nearest (CIE76) a colour measured on the painting. */
export function nearestCentre(cls: PaletteClass, target: LinearRGB): LinearRGB {
  const lab = linearToLab(target);
  const dE = (c: LinearRGB): number => deltaE76(linearToLab(c), lab);
  return cls.centres.reduce((a, c) => (dE(c.linear) < dE(a) ? c.linear : a), cls.median.linear);
}
